import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import SearchBox from '../components/SearchBox';
import PersonResultCard from '../components/PersonResultCard';

export default function Results() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const navigate = useNavigate();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState(query);

  useEffect(() => {
    if (!query) {
      navigate('/');
      return;
    }
    setLoading(true);
    api.get('/search', { params: { q: query } })
      .then(({ data }) => {
        setResults(data.results);
        setLoading(false);
      })
      .catch(() => {
        setError('Erro ao realizar a busca. Tente novamente.');
        setLoading(false);
      });
  }, [query]);

  const handleNewSearch = (term) => {
    navigate(`/resultados?q=${encodeURIComponent(term)}`);
  };

  const handleSelect = (person) => {
    navigate('/captura', {
      state: { person, searchTerm: query },
    });
  };

  const handleBack = () => navigate('/');

  if (loading) {
    return (
      <div className="results-page">
        <div className="container results-container">
          <div className="empty-state">
            <h3>Buscando...</h3>
            <p>Procurando registros de sepultados</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="results-page">
        <div className="container results-container">
          <span className="back-link" onClick={handleBack}>← Nova busca</span>
          <div className="not-found">
            <h2>Erro na busca</h2>
            <p>{error}</p>
            <button className="btn-primary" onClick={handleBack}>VOLTAR</button>
          </div>
        </div>
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className="results-page">
        <div className="container results-container">
          <span className="back-link" onClick={handleBack}>← Nova busca</span>
          <div className="not-found">
            <h2>Pessoa não encontrada</h2>
            <p>Não encontramos registros para "<strong>{query}</strong>". Tente o sobrenome (sem acentos) ou uma parte do nome.</p>
            <button className="btn-primary" onClick={handleBack}>NOVA BUSCA</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="results-page">
      <div className="container results-container">
        <span className="back-link" onClick={handleBack}>← Nova busca</span>

        <div style={{ marginBottom: 24 }}>
          <SearchBox
            value={searchTerm}
            onChange={setSearchTerm}
            onSubmit={handleNewSearch}
            loading={false}
          />
        </div>

        <h2 style={{ marginBottom: 8 }}>
          {results.length === 1 ? 'Pessoa encontrada' : 'Encontramos pessoas com esse nome'}
        </h2>
        <p style={{ color: 'var(--texto-secundario)', marginBottom: 24 }}>
          {results.length === 1
            ? 'Confirme se esta é a pessoa que você está procurando:'
            : 'Selecione a pessoa que você está procurando:'}
        </p>

        {results.map((person) => (
          <PersonResultCard
            key={person.id}
            person={person}
            onClick={() => handleSelect(person)}
          />
        ))}

        {results.length === 1 && (
          <div style={{ marginTop: 24, textAlign: 'center' }}>
            <button
              className="btn-primary"
              onClick={() => handleSelect(results[0])}
              style={{ minWidth: 200 }}
            >
              CONTINUAR
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
